import FilterList from 'projects/access-control/src/app/Domain/Entities/filter-list.interface';

const filtersResourceTable: FilterList[] = [
	{
		label: 'Name',
		key: 'name',
		value: '',
		placeHolder: 'Enter a name',
		type: 'text',
	},
	{
		label: 'Action ',
		key: 'action',
		value: '',
		placeHolder: 'Enter a action',
		type: 'text',
	},
	{
		label: 'Path ',
		key: 'path',
		value: '',
		placeHolder: 'Enter a path',
		type: 'text',
	},
];

export default filtersResourceTable;
